// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"wb-z"};